import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d90b706"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agents-table--cell" }
const _hoisted_2 = { class: "agents-table--cell-content" }
const _hoisted_3 = { class: "ml-1 text-ellipsis overflow-hidden items-center !leading-[24px]" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsLinuxLicenseCell',
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(["flex text-[24px] !leading-[24px]", [__props.value ? 'uil uil-check text-Text/text_primary' : 'uil uil-times']])
      }, null, 2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.value ? 'Subscribed' : 'Unsubscribed'), 1)
    ])
  ]))
}
}

})